import Grid from '@material-ui/core/Grid';
import GridFormField from 'shared/components/GridFormField';
import React from 'react';
import removeHTML from 'shared/utils/removeHTML';
import Typography from '@material-ui/core/Typography';
import {
	dateInRange,
	isAfterDob,
	maxStrLength,
	numericValidation,
	phoneNumberValidation,
	settingValidation,
	isValidDate,
} from 'shared/utils/validations';
import { formatNumber, formatPhone, parseNumber, parsePhone } from 'shared/utils/formatting';
import { FormSection } from 'redux-form';
import { PropTypes } from 'prop-types';
import {
	CURRENT_RESIDENCE,
	DATE_RANGE_START_YEAR,
	DATE_RANGE_START_MONTH,
	DATE_RANGE_START_DAY,
} from './constants';

const CurrentResidenceFields = ({ disableAll, settings, name }) => (
	<FormSection name={name} style={{ width: '100%' }}>
		<Grid container spacing={5}>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.HousingIndicatorLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.HousingIndicatorDescription}
				fieldSettings={settings.primary.housingOwnOrRent}
				name="housingIndicator"
				select
				menuOptions={settings.comboFields.PRIMARYHOUSING}
				validation={settingValidation(settings.primary.housingOwnOrRent)}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.HomePhoneLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.HomePhoneDescription}
				fieldSettings={settings.primary.homePhone}
				name="homePhone"
				validation={[settingValidation(settings.primary.homePhone), phoneNumberValidation('US')]}
				disabled={disableAll}
				format={formatPhone('US')}
				parse={parsePhone('US')}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CellPhoneLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CellPhoneDescription}
				fieldSettings={settings.primary.cellPhone}
				name="cellPhone"
				validation={[settingValidation(settings.primary.cellPhone), phoneNumberValidation('US')]}
				disabled={disableAll}
				format={formatPhone('US')}
				parse={parsePhone('US')}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.ResidenceStartDateLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.ResidenceStartDateDescription}
				fieldSettings={settings.primary.housingTimeAtResidence}
				type="date"
				inputProps={{ 
					style: { textTransform: 'uppercase', marginTop: '16px' }, 
					placeholder: 'MM/dd/yyyy' }}
				labelShrink
				name="currentAddressTermStart"
				validation={[
					settingValidation(settings.primary.housingTimeAtResidence),
					isValidDate,
					dateInRange(
						new Date(DATE_RANGE_START_YEAR, DATE_RANGE_START_MONTH, DATE_RANGE_START_DAY),
						new Date(Date.now()),
					),
					isAfterDob,
				]}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.MonthlyPaymentLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.MonthlyPaymentDescription}
				fieldSettings={settings.primary.housingMonthlyPayment}
				name="monthlyRent"
				validation={[
					settingValidation(settings.primary.housingMonthlyPayment),
					maxStrLength(5),
					numericValidation,
				]}
				format={formatNumber}
				parse={parseNumber}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.HomeValueLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.HomeValueDescription}
				fieldSettings={settings.primary.housingHomeValue}
				name="homeValue"
				validation={[
					settingValidation(settings.primary.housingHomeValue),
					maxStrLength(7),
					numericValidation,
				]}
				format={formatNumber}
				parse={parseNumber}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.MortgageBalanceLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.MortgageBalanceDescription}
				fieldSettings={settings.primary.housingMortgageBalance}
				name="mortgageBalance"
				validation={[
					settingValidation(settings.primary.housingMortgageBalance),
					maxStrLength(7),
					numericValidation,
				]}
				format={formatNumber}
				parse={parseNumber}
				disabled={disableAll}
			/>
		</Grid>
		<Typography type="caption" component="div" style={{ paddingTop: '20px' }}>
			<div
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{
					__html: removeHTML(settings.fieldAndFooterSettings.ApplicationPageSettings.CurrentResidenceFooter),
				}}
			/>
		</Typography>
	</FormSection>
);

CurrentResidenceFields.propTypes = {
	disableAll: PropTypes.bool,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
	}),
	name: PropTypes.string,
};

CurrentResidenceFields.defaultProps = {
	disableAll: false,
	settings: {},
	name: CURRENT_RESIDENCE,
};

export default CurrentResidenceFields;
